/** @jsx jsx */
import * as React from 'react'
import { jsx, useThemeUI } from 'theme-ui'
import { DynamicSparkIcon } from '../helpers/dynamic-spark-icon'

const ListItem = ({ children, variant, listType = 'bullet', ...props }) => {
  const { theme } = useThemeUI()

  const element = theme?.elements?.list || theme?.list || {} // latter is backwards compatibility
  const before = element?.[listType]?.['::before'] || element?.[listType]?.[':before'] || {}
  const sx = {
    marginBottom: 'sm',
    counterIncrement: 'li',
    position: 'relative',
    paddingLeft: 'md',
    // handle bug in eevee that results in incorrect extra spacing
    p: {
      display: 'inline',
    },
    '::before': {
      // https://www.w3.org/Style/Examples/007/color-bullets.en.html
      position: 'absolute',
      left: '0',
      textAlign: 'right',
      direction: 'rtl',
    },
  }

  if (listType === 'bullet') {
    sx['::before'] = {
      content: '"• "',
      color: element && element.bullet ? element.bullet.color : 'black',
      ...sx['::before'],
      ...before,
    }
  } else if (listType === 'numeric') {
    sx['::before'] = {
      content: 'counter(li)',
      color: element && element.numeric ? element.numeric.color : 'black',
      ...sx['::before'],
      ...before,
    }
  }

  return (
    <li sx={sx} {...props}>
      <If condition={variant}>
        <DynamicSparkIcon
          color={theme.elements?.list[variant]?.color}
          glyph={theme.elements?.list[variant]?.glyph}
          size={24}
        />
      </If>
      {children}
    </li>
  )
}

export default ListItem
